var map = {
	"./Application.jpg": 1557,
	"./Game.jpg": 1558,
	"./Music.jpg": 1559,
	"./Video.jpg": 1560,
	"./Wallpaper.jpg": 1561,
	"./Yummy Recipe.jpg": 1562,
	"./Yummy-Recipe.jpg": 1563
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1556;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobizone/imgs/browse ^\.\/.*\.jpg$
// module id = 1556
// module chunks = 0